// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1_VN1","content":"styles_content__2CwYY","checkbox":"styles_checkbox__1Af96","checkboxLabel":"styles_checkboxLabel__3poZj"};